module.exports = __webpack_public_path__ + "static/media/aboutUAICLayout.3abbacff.svg";